module.exports = __webpack_public_path__ + "img/功耗使用.ad20f084.png";